import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=f8d1829c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d1829c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8d1829c')) {
      api.createRecord('f8d1829c', component.options)
    } else {
      api.reload('f8d1829c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=f8d1829c&scoped=true&", function () {
      api.rerender('f8d1829c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h8Dha5MgiPrv/JS/comp/Accordion.vue"
export default component.exports